import React from "react";

const TimesheetStatusChips = ({ options, selectedValue, onChange }) => {
  return (
    <div
      className="timesheet-status-chips flex min-w-0 flex-1 flex-wrap items-center gap-1.5"
      role="tablist"
      aria-label="Filter by status"
    >
      {options.map((opt) => {
        const isActive = selectedValue === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(opt)}
            className={`timesheet-status-chip ${
              isActive ? "timesheet-status-chip--active" : ""
            }`}
          >
            <span className="timesheet-status-chip__label">{opt.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default TimesheetStatusChips;
